export const SIGN_IN_DISCLAIMER_INTRO =
  'By using ParachuteIQ, you acknowledge and agree to the following terms. Please read carefully before proceeding.';

export const SIGN_IN_DISCLAIMER_VERSION = 'ParachuteIQ, Inc. · Terms of Use v1.0';

export const SIGN_IN_DISCLAIMER_SECTIONS = [
  {
    title: 'Accuracy of User-Provided Data',
    body: 'The analysis generated by ParachuteIQ is based solely on the information you provide. ParachuteIQ does not independently verify the accuracy, completeness, or currentness of any data you enter, including but not limited to compensation figures, equity award details, share counts, vesting schedules, employment dates, or transaction terms. You are solely responsible for ensuring that all inputs are accurate and complete. Inaccurate or incomplete data will produce inaccurate results.',
  },
  {
    title: 'Not Legal, Tax, or Financial Advice',
    body: 'ParachuteIQ is a computational tool designed to assist with the analysis of potential parachute payments under Section 280G of the Internal Revenue Code. The output of this tool does not constitute legal advice, tax advice, financial advice, or any other form of professional advice.',
  },
  {
    title: 'No Attorney-Client Relationship',
    body: 'Your use of ParachuteIQ does not create an attorney-client relationship, accountant-client relationship, or any other professional advisory relationship between you and ParachuteIQ, Inc. or any of its affiliates.',
  },
  {
    title: 'Regulatory Complexity & Limitations',
    body: 'Section 280G and related Treasury Regulations involve nuanced rules that may require fact-specific analysis beyond the scope of this tool. Certain determinations may require professional judgment that cannot be fully automated.',
  },
  {
    title: 'Confidentiality & Data Security',
    body: 'The information you enter into ParachuteIQ may include sensitive, proprietary, and material nonpublic information. While ParachuteIQ employs commercially reasonable security measures, you are responsible for ensuring compliant use.',
  },
  {
    title: 'Shareholder Approval Documents',
    body: 'Any shareholder disclosure statements, consent forms, or other documents generated by ParachuteIQ are templates and must be reviewed by qualified legal counsel before use.',
  },
  {
    title: 'Limitation of Liability',
    body: 'To the maximum extent permitted by law, ParachuteIQ, Inc. shall not be liable for damages arising out of or in connection with your use of this tool.',
  },
  {
    title: 'Professional Review Required',
    body: 'All output from ParachuteIQ should be reviewed by qualified professionals before being relied upon or distributed.',
  },
] as const;

export const SIGN_IN_DISCLAIMER_ACKNOWLEDGEMENT =
  'I acknowledge that I have read and understand the terms above. I understand that the analysis is based on the data I provide and does not constitute legal or tax advice.';
